module.exports = "<block class=\"example-middle\">\n    <div slot=\"middle\" class=\"example-middle-txt\">This is a message in the middle of box.</div>\n</block>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/example/4-middle.html
// module id = 209
// module chunks = 1